const axios = require('axios').default;

export const getSuppliersConfig = (props = {token:"", env:""}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getSuppliersConfig`,
    {
        params: {
            env:props.env
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const getSupplierInventoryByPOTemplate = (props = {token:"", poId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getPurchaseOrdersItemsByPOId`, 
    {   
        params:{ 
            id:JSON.stringify([props.poId])
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const getSupplierInventory = (props = {token:"", branchId:null, supplierId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getGoodsInfoList`,{
        params:{
            branchId:props.branchId,
            supplierId:props.supplierId
        },
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const getInventoryBranchMapping = (props = {token:"", supplierId:0}) => {  
    return axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/inventoryBranchMapping/${props.supplierId}`, {
        headers: {
            "Authorization": 'Basic ' + props.token
        }
    });
}

export const getSupplierGoodsInfo = (props = {token:"", supplierId:0}) => {  
    return axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/goodsInfo/${props.supplierId}`, {
        headers: {
            "Authorization": 'Basic ' + props.token
        }
    });
}

export const getSupplierBranchCodeByBranchId = (props = {token:"", supplierId:0, branchId:0}) => {  
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getSupplierBranchCodeByBranchId/${props.supplierId}/${props.branchId}`, {
        headers: {
            "Authorization": 'Basic ' + props.token
        }
    });
}

export const getSupplierInventoryByBusinessId = (props = {token:"", businessId:0}) => {  
    return axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/inventoryByBusinessId/${props.businessId}`, {
        headers: {
            "Authorization": 'Basic ' + props.token
        }
    });
}

export const getSupplierByBusinessId = (props = {token:"", businessId: 0}) => {  
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getSuppliersByBusinessId/${props.businessId}`, {
        headers: {
            "Authorization": 'Basic ' + props.token
        }
    });
}

export const getSupplierDeliveryLines = (props = {token:"", supplierId: 0}) => {  
    return axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/deliveryLines/${props.supplierId}`, {
        headers: {
            "Authorization": 'Basic ' + props.token
        }
    });
}

export const getTemporaryDeliveryLineDates = (props = {token:"", supplierId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/temporaryDeliveryLines/transferDates/${props.supplierId}`, {
        headers: {
            "Authorization": 'Basic ' + props.token
        }
    });
}


export const getTemporaryDeliveryLines = (props = {token:"", supplierId: 0, date:'0000-00-00'}) => {  
    return axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/temporaryDeliveryLines/${props.supplierId}`,{
        params: {
            date:props.date
        },
        headers: {
            "Authorization": 'Basic ' + props.token
        }
    });
}

export const putDeliveryLineBranchSortOrder = (props = {token:"", supplierId:0, payload:[]}) => {
    return axios.put(`${process.env.REACT_APP_API_URL}/api/supplier/deliveryLineBranchSortOrder/`,{
        data:JSON.stringify(props.payload),
        params: {
            supplierId:props.supplierId
        }
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const putTemporaryDeliveryLineTransfer = (props = {token:"", supplierId:0, added:[], removed:[], updated:[]}) => {
    return axios.put(`${process.env.REACT_APP_API_URL}/api/supplier/temporaryDeliveryLineTransfer/`,{
        //data:JSON.stringify(props.payload),
        added:props.added,
        removed:props.removed,
        updated:props.updated,
        params: {
            supplierId:props.supplierId
        }
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const getSupplierPurchaseOrderStorageDates = (props = {token:"", supplierId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/purchaseOrder/storageDates/${props.supplierId}`, {
        headers: {
            "Authorization": 'Basic ' + props.token
        }
    });
}

export const getSupplierOperators = (props = {token:"", supplierId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/operators/${props.supplierId}`, {
        headers: {
            "Authorization": 'Basic ' + props.token
        }
    });
}

export const postDeliveryLinesQualityAssurance = (props = {token:"", payload:{}}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/supplier/deliveryLinesQualityAssurance/`,{
        data:JSON.stringify(props.payload)
    },{
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}

export const getDeliveryLinesQualityAssurance = (props = {token:"", supplierId:0, storageDate:'0000-00-00'}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/supplier/deliveryLinesQualityAssurance/`,{
        params:{
            supplierId:props.supplierId,
            storageDate:props.storageDate
        },
        headers: {
            Authorization: 'Basic ' + props.token
        }
    });
}